module.exports = __webpack_public_path__ + "img/junior.cb082c2b.jpg";